import api from '../../../api/apiClient';
import { formatDate, strToNumber } from '../../shared/utils/misc';

const unwrap = async (promise) => {
  const res = await promise;
  return res.data;
};

export const postHiringRequest = async (data) => {
  if (!data) return;
  const payload = {
    designation: data.designation,
    department: data.department,
    work_arrangement: data.workArrangement,
    employment_type: data.employmentType,
    min_age_preferred: data.minAge,
    max_age_preferred: data.maxAge,
    gender_preferred: data.genderPreference,
    qualification_preferred: data.qualificationPreference,
    responsibilities:
      data.responsibilities
        ?.split('\n')
        .map((r) => r.trim())
        .filter(Boolean) || [],
    tools: Array.isArray(data.toolsRequired)
      ? data.toolsRequired.map((t) => t.trim()).filter(Boolean)
      : [],
    min_experience_required: data.minExperience,
    max_experience_required: data.maxExperience,
    min_ctc: data.minCTC,
    max_ctc: data.maxCTC,
    no_of_positions: data.noOfPositions,
    status: data.status || 'active',
  };
  await unwrap(await api.post('/api/hr/add-job-posting', payload));
};

export const updateHiringRequest = async (id, data) => {
  if (!id || !data) throw new Error('Candidate id and schedule is required');
  const payload = {
    designation: data.designation,
    department: data.department,
    work_arrangement: data.workArrangement,
    employment_type: data.employmentType,
    min_age_preferred: String(data.minAge),
    max_age_preferred: String(data.maxAge),
    gender_preferred: data.genderPreference,
    qualification_preferred: data.qualificationPreference,
    responsibilities: Array.isArray(data.responsibilities)
      ? data.responsibilities
      : data.responsibilities
          ?.split('\n')
          .map((r) => r.trim())
          .filter(Boolean) || [],
    tools: Array.isArray(data.toolsRequired)
      ? data.toolsRequired
      : data.toolsRequired
          ?.split(',')
          .map((t) => t.trim())
          .filter(Boolean) || [],
    min_experience_required: String(data.minExperience),
    max_experience_required: String(data.maxExperience),
    min_ctc: strToNumber(data.minCTC),
    max_ctc: strToNumber(data.maxCTC),
    no_of_positions: data.noOfPositions,
    status: data.status || 'active',
  };
  await unwrap(await api.put(`/api/hr/job-posting/${id}/update`, { id, ...payload }));
};

export const deleteHiringRequest = async (id) => {
  if (!id) return;
  await unwrap(await api.delete(`/api/hr/job-posting/${id}/delete`));
};

export const getAllJobPostings = async () => {
  const { data: raw } = await unwrap(await api.get('/api/hr/job-postings'));
  return raw.map((job) => ({
    id: job.id,
    designation: job.designation,
    department: job.department,
    workArrangement: job.work_arrangement,
    employmentType: job.employment_type,
    minAge: job.min_age_preferred,
    maxAge: job.max_age_preferred,
    genderPreference: job.gender_preferred,
    qualificationPreference: job.qualification_preferred,
    responsibilities: Array.isArray(job.responsibilities)
      ? job.responsibilities
      : job.responsibilities
          ?.split('\n')
          .map((r) => r.trim())
          .filter(Boolean) || [],
    toolsRequired: Array.isArray(job.tools)
      ? job.tools
      : job.tools
          ?.split(',')
          .map((t) => t.trim())
          .filter(Boolean) || [],
    minExperience: job.min_experience_required,
    maxExperience: job.max_experience_required,
    minCTC: strToNumber(job.min_ctc),
    maxCTC: strToNumber(job.max_ctc),
    noOfPositions: job.no_of_positions,
    postedOn: formatDate(job.posted_on),
    applications: job.applications,
    status: job.status,
  }));
};
